// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__xTnIT","modal":"Modal_modal__DJDMv","buttonClose":"Modal_buttonClose__5LpkD","buttonIcon":"Modal_buttonIcon__nkDZx"};